var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiscina(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78516 13.0068H16.8173",
    stroke: "#2B363D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93359 9.56445L16.8183 9.56445",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0787 15.5129V7.42604C17.0787 6.08606 15.9926 5 14.6526 5C13.3126 5 12.2266 6.08606 12.2266 7.42604",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28178 15.5129C9.28178 15.5129 9.28178 10.5841 9.28178 7.42604C9.28178 6.08606 8.19572 5 6.85573 5C5.51575 5 4.42969 6.08606 4.42969 7.42604",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4098 18.7603C20.8244 18.7603 20.2389 18.9624 19.7926 19.3668C19.3462 19.7711 18.7608 19.9733 18.1753 19.9733M18.1761 19.9806C17.5907 19.9806 17.0053 19.7784 16.5589 19.374C16.1125 18.9697 15.5271 18.7675 14.9416 18.7675C14.3562 18.7675 13.7708 18.9697 13.3244 19.374C12.878 19.7784 12.2926 19.9806 11.7072 19.9806C11.1217 19.9806 10.5363 19.7784 10.0899 19.374C9.64354 18.9697 9.0581 18.7675 8.47266 18.7675",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4062 15.5073C20.8207 15.5073 20.2353 15.7095 19.7889 16.1138C19.3426 16.5182 18.7571 16.7203 18.1717 16.7203M18.1725 16.7276C17.587 16.7276 17.0016 16.5255 16.5552 16.1211C16.1089 15.7168 15.5234 15.5146 14.938 15.5146C14.3525 15.5146 13.7671 15.7168 13.3207 16.1211C12.8744 16.5255 12.2889 16.7276 11.7035 16.7276C11.118 16.7276 10.5326 16.5255 10.0862 16.1211C9.63988 15.7168 9.05444 15.5146 8.46899 15.5146C7.88355 15.5146 7.29811 15.7168 6.85174 16.1211C6.40538 16.5255 5.81994 16.7276 5.2345 16.7276C4.64905 16.7276 4.06361 16.5255 3.61725 16.1211C3.17089 15.7168 2.58544 15.5146 2 15.5146",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiscina);
export default __webpack_public_path__ + "static/media/Piscina.6b2fe65449774bec10146a620bef6d3a.svg";
export { ForwardRef as ReactComponent };